import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, clearError } from '../../actions/authActions';
import { closeModal } from '../../actions/modalActions';
import Modal from '../common/Modal';
import dgesLogo from '../../assets/images/dges-logo.png';

const LoginModal = () => {
  const dispatch = useDispatch();
  const { loading, error, isAuthenticated } = useSelector(state => state.auth);
  const { darkMode } = useSelector(state => state.ui);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    dispatch(clearError());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(closeModal());
    }
  }, [isAuthenticated, dispatch]);

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(login(username, password));
  };

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Modal onClose={handleClose}>
      <div className="text-center">
        {/* DGES Logo & Branding */}
        <div className="mb-5 flex flex-col items-center">
          <div className="mb-3 flex items-center justify-center gap-3">
            <img src={dgesLogo} alt="DGES Logo" className="h-14 w-auto object-contain" />
          </div>
          <h2 className="text-3xl font-black tracking-widest" style={{color: '#F5A500'}}>DGES</h2>
          <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase">Point of Sale System</p>
        </div>

        <form onSubmit={handleLogin} className="mt-5">
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            className="w-full px-4 py-3 mb-4 border rounded-lg focus:ring-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            style={{'--tw-ring-color': '#F5A500', borderColor: username ? '#F5A500' : undefined}}
            onFocus={e => e.target.style.borderColor = '#F5A500'}
            onBlur={e => e.target.style.borderColor = ''}
            required
            disabled={loading}
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full px-4 py-3 mb-4 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            onFocus={e => e.target.style.borderColor = '#F5A500'}
            onBlur={e => e.target.style.borderColor = ''}
            required
            disabled={loading}
          />
          {error && (
            <div className="text-red-500 mb-4 p-2 bg-red-50 dark:bg-red-900/20 rounded-lg">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 text-black font-black rounded-lg transition-all hover:shadow-lg hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed tracking-widest text-sm"
            style={{backgroundColor: '#F5A500'}}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <i className="fas fa-spinner fa-spin mr-2"></i>
                Signing In...
              </span>
            ) : (
              'SIGN IN'
            )}
          </button>
        </form>

        <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
          <p className="text-xs text-gray-400">
            © 2025 DGES. All rights reserved.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default LoginModal;
